import axios from "axios";
import { prodEnv } from "../components/env/environment";

const apiUrl = prodEnv.API_URL;
// Helper function to create authenticated headers
const getAuthHeaders = () => {
  const token = sessionStorage.getItem("token");
  if (!token) {
    throw new Error("No authentication token found. Please login again.");
  }
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

// User signup
export const signup = async (userData) => {
  try {
    const response = await axios.post(`${apiUrl}/users/createUser`, userData, {
      headers: { "Content-Type": "application/json" },
    });
    if (response.data.token) {
      sessionStorage.setItem("token", response.data.token);
      const user = {
        id: response.data.userId,
        email: userData.email,
      };
      sessionStorage.setItem("user", JSON.stringify(user));
    }
    return response.data;
  } catch (error) {
    console.error(
      "Error during signup:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

// User login
export const login = async (credentials) => {
  try {
    const response = await axios.post(
      `${apiUrl}/users/loginUser`,
      credentials,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    if (response.data.token) {
      sessionStorage.setItem("token", response.data.token);
      const user = {
        id: response.data.userId,
        email: credentials.email,
      };
      sessionStorage.setItem("user", JSON.stringify(user));
    }
    return response.data;
  } catch (error) {
    console.error(
      "Error during login:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

// User logout
export const logout = () => {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("user");
};

// Get music recommendations based on mood text
export const getMusicByMood = async (mood) => {
  try {
    const response = await axios.post(
      `${apiUrl}/music/getMusic/text`,
      { text: mood, songCount: 5 },
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching music by emotion:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const getMusicByCoordinates = async (lat, lon) => {
  try {
    const response = await axios.post(
      `${apiUrl}/music/getMusic/location`,
      { latitude: lat, longitude: lon, songCount: 5 },
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching music by coordinates:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

// Get music recommendations based on city and country
export const getMusicByCity = async (city, country) => {
  try {
    const response = await axios.post(
      `${apiUrl}/music/getMusic/location`,
      { city, country, songCount: 5 },
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching music by city:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

// Get next page of music results
export const getNextPage = async (nextPageUrl) => {
  try {
    const response = await axios.get(nextPageUrl, {
      headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching next page:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};
